(function ($) {
  DJ.addBehavior('inputErrors', 'body', {
    attach: function () {
      const block = document.getElementById('node-project-idea-diploma-project');

      if (!block) return;

      const mainButton = block.querySelector('.ief-entity-submit');
      const wrapper = mainButton.closest('div');

      if (!mainButton.classList.contains('error')) {
        return;
      }

      const GAP = 30;
      const header = document.querySelector('.header');
      const errorText = "Veuillez valider l'association";
      const errorBlock = document.createElement('div');
      errorBlock.classList.add('form-item-error-message', 'form-item-error-message--centered');
      errorBlock.innerText = errorText;
      wrapper.append(errorBlock);

      setTimeout(() => {
        $([document.documentElement, document.body]).animate({
          scrollTop: $(block).offset().top - header.offsetHeight - GAP
        }, 800);
      }, 200);
    }
  });
})(jQuery);
